export default __webpack_public_path__ + "static/media/ad.0e127be7.png";